interface Props {
  children: React.ReactNode;
}

export default function TableHead({ children }: Props) {
  return <div className="flex-1 truncate text-slate-100">{children}</div>;
}
